"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutlinedInputWithLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

var _icons = require("../../icons");

var _colors = require("../../theme/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    labelBox: {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      marginBottom: '1rem'
    },
    label: {
      display: 'inline-block',
      fontSize: '0.875rem',
      color: _colors.colors.black80
    },
    infoIconWrapper: {
      display: 'inline-block'
    },
    adornment: {
      fontSize: '0.875rem',
      color: _colors.colors.black47
    },
    inputRoot: function inputRoot(props) {
      return {
        backgroundColor: _colors.colors.bg1,
        padding: '0.625rem 0.75rem',
        borderRadius: '0.5rem',
        border: "1px solid ".concat(_colors.colors.black47),
        fontSize: '0.875rem',
        height: props.multiline ? undefined : '2.5rem',
        '&:hover': {
          border: "1px solid ".concat(_colors.colors.black80)
        }
      };
    },
    inputInput: function inputInput(props) {
      return {
        padding: 0,
        lineHeight: props.multiline ? '1.2rem' : undefined
      };
    },
    inputFocused: {
      border: "1px solid ".concat(_colors.colors.primaryGreen)
    },
    inputDisabled: {
      borderColor: "1px solid ".concat(_colors.colors.dataGrey),
      backgroundColor: _colors.colors.bg3,
      color: _colors.colors.black80
    },
    inputError: {
      border: "1px solid ".concat(_colors.colors.errorRed)
    },
    errorMessage: {
      paddingTop: '0.5rem',
      paddingLeft: '0.75rem',
      color: _colors.colors.errorRed,
      fontSize: '0.75rem',
      lineHeight: '1rem'
    },
    tooltip: {
      background: _colors.colors.bg1,
      border: "1px solid ".concat(_colors.colors.primaryGreen),
      borderRadius: '0.5rem',
      color: _colors.colors.black
    },
    arrow: {
      color: _colors.colors.primaryGreen
    }
  };
});

function NumberFormatCustom(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      _props$thousandSepara = props.thousandSeparator,
      thousandSeparator = _props$thousandSepara === void 0 ? ' ' : _props$thousandSepara,
      _props$decimalSeparat = props.decimalSeparator,
      decimalSeparator = _props$decimalSeparat === void 0 ? ',' : _props$decimalSeparat,
      other = _objectWithoutProperties(props, ["inputRef", "onChange", "thousandSeparator", "decimalSeparator"]);

  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat["default"], _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: thousandSeparator,
    decimalSeparator: decimalSeparator,
    isNumericString: true
  }));
}

var OutlinedInputWithLabel = function OutlinedInputWithLabel(props) {
  var classes = useStyles(props);

  var value = props.value,
      label = props.label,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      handleChange = props.handleChange,
      disabled = props.disabled,
      adornment = props.adornment,
      placeholder = props.placeholder,
      tooltip = props.tooltip,
      error = props.error,
      errorMessage = props.errorMessage,
      formatInput = props.formatInput,
      thousandSeparator = props.thousandSeparator,
      decimalSeparator = props.decimalSeparator,
      multiline = props.multiline,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? multiline ? 2 : undefined : _props$rows,
      restProps = _objectWithoutProperties(props, ["value", "label", "type", "handleChange", "disabled", "adornment", "placeholder", "tooltip", "error", "errorMessage", "formatInput", "thousandSeparator", "decimalSeparator", "multiline", "rows"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  return /*#__PURE__*/_react["default"].createElement(_core.Box, restProps, label && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    m: 1,
    className: classes.labelBox
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    className: classes.label,
    id: "select-label-".concat(label)
  }, label), !!tooltip && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    classes: {
      tooltip: classes.tooltip,
      arrow: classes.arrow
    },
    placement: "right",
    arrow: true,
    open: open,
    onClose: handleClose,
    onOpen: handleOpen,
    title: tooltip,
    disableFocusListener: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.infoIconWrapper,
    pl: 1,
    onClick: handleOpen
  }, /*#__PURE__*/_react["default"].createElement(_icons.Faq, {
    fontSize: "small"
  })))), /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_core.InputBase, {
    value: value,
    onChange: handleChange,
    classes: {
      root: classes.inputRoot,
      input: classes.inputInput,
      disabled: classes.inputDisabled,
      focused: classes.inputFocused,
      error: classes.inputError
    },
    type: type,
    endAdornment: adornment && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
      position: "end",
      className: classes.adornment,
      disableTypography: true,
      disablePointerEvents: true
    }, adornment),
    disabled: disabled,
    fullWidth: true,
    placeholder: placeholder,
    error: error,
    inputProps: {
      thousandSeparator: thousandSeparator,
      decimalSeparator: decimalSeparator
    },
    inputComponent: formatInput ? NumberFormatCustom : 'input',
    multiline: multiline,
    rows: rows,
    rowsMin: rows
  })), error && errorMessage && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.errorMessage
  }, errorMessage));
};

exports.OutlinedInputWithLabel = OutlinedInputWithLabel;